module.exports = __webpack_public_path__ + "static/media/GirlPower.c8e52bcb.png";